// @generated drizzle-zero signature:sha256:3e13712449490700ba2ecbd762bb4e8509a08990949645460ff90d3401f2d4af
// This file was automatically generated by drizzle-zero.
// You should NOT make any changes in this file as it will be overwritten.
import { createBuilder } from "@rocicorp/zero";
const accountTable = {
    name: "account",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        accountId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "account_id",
        },
        providerId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "provider_id",
        },
        userId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "user_id",
        },
        accessToken: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "access_token",
        },
        refreshToken: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "refresh_token",
        },
        idToken: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "id_token",
        },
        accessTokenExpiresAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "access_token_expires_at",
        },
        refreshTokenExpiresAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "refresh_token_expires_at",
        },
        scope: {
            type: "string",
            optional: true,
            customType: null,
        },
        password: {
            type: "string",
            optional: true,
            customType: null,
        },
        passwordSetupCompletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "password_setup_completed_at",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
    },
    primaryKey: ["id"],
};
const adminUserTable = {
    name: "adminUser",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        email: {
            type: "string",
            optional: false,
            customType: null,
        },
        emailVerified: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "email_verified",
        },
        image: {
            type: "string",
            optional: true,
            customType: null,
        },
        role: {
            type: "string",
            optional: true,
            customType: null,
        },
        banned: {
            type: "boolean",
            optional: true,
            customType: null,
        },
        banReason: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "ban_reason",
        },
        banExpires: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "ban_expires",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
    },
    primaryKey: ["id"],
    serverName: "admin_user",
};
const licenceTable = {
    name: "licence",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        organisationId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "organisation_id",
        },
        installationId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "installation_id",
        },
        jwt: {
            type: "string",
            optional: false,
            customType: null,
        },
        type: {
            type: "string",
            optional: false,
            customType: null,
        },
        limits: {
            type: "json",
            optional: true,
            customType: null,
        },
        country: {
            type: "string",
            optional: false,
            customType: null,
        },
        issuedAt: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "issued_at",
        },
        expiresAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "expires_at",
        },
        revokedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "revoked_at",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
};
const organisationTable = {
    name: "organisation",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        internalId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "internal_id",
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        country: {
            type: "string",
            optional: false,
            customType: null,
        },
        street: {
            type: "string",
            optional: true,
            customType: null,
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        type: {
            type: "string",
            optional: false,
            customType: null,
        },
        isDemo: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "is_demo",
        },
        lastActivityAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "last_activity_at",
        },
        hmsUrl: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "hms_url",
        },
        deployedVersion: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deployed_version",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
};
const organisationUserTable = {
    name: "organisationUser",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        organisationId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "organisation_id",
        },
        userId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "user_id",
        },
        username: {
            type: "string",
            optional: true,
            customType: null,
        },
        email: {
            type: "string",
            optional: false,
            customType: null,
        },
        firstName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "first_name",
        },
        lastName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "last_name",
        },
        groups: {
            type: "json",
            optional: true,
            customType: null,
        },
        active: {
            type: "boolean",
            optional: false,
            customType: null,
        },
        snapshotGeneratedAt: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "snapshot_generated_at",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
    },
    primaryKey: ["id"],
    serverName: "organisation_user",
};
const sessionTable = {
    name: "session",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        token: {
            type: "string",
            optional: false,
            customType: null,
        },
        expiresAt: {
            type: "number",
            optional: false,
            customType: null,
            serverName: "expires_at",
        },
        ipAddress: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "ip_address",
        },
        userAgent: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "user_agent",
        },
        userId: {
            type: "string",
            optional: false,
            customType: null,
            serverName: "user_id",
        },
        impersonatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "impersonated_by",
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
    },
    primaryKey: ["id"],
};
const userTable = {
    name: "user",
    columns: {
        id: {
            type: "string",
            optional: false,
            customType: null,
        },
        name: {
            type: "string",
            optional: false,
            customType: null,
        },
        email: {
            type: "string",
            optional: false,
            customType: null,
        },
        emailVerified: {
            type: "boolean",
            optional: true,
            customType: null,
            serverName: "email_verified",
        },
        image: {
            type: "string",
            optional: true,
            customType: null,
        },
        username: {
            type: "string",
            optional: true,
            customType: null,
        },
        displayUsername: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "display_username",
        },
        firstName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "first_name",
        },
        lastName: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "last_name",
        },
        role: {
            type: "string",
            optional: true,
            customType: null,
        },
        banned: {
            type: "boolean",
            optional: true,
            customType: null,
        },
        banReason: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "ban_reason",
        },
        banExpires: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "ban_expires",
        },
        status: {
            type: "string",
            optional: true,
            customType: null,
        },
        createdAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "created_at",
        },
        updatedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "updated_at",
        },
        deletedAt: {
            type: "number",
            optional: true,
            customType: null,
            serverName: "deleted_at",
        },
        createdBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "created_by",
        },
        updatedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "updated_by",
        },
        deletedBy: {
            type: "string",
            optional: true,
            customType: null,
            serverName: "deleted_by",
        },
    },
    primaryKey: ["id"],
};
const accountRelationships = {
    user: [
        {
            sourceField: ["userId"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const licenceRelationships = {
    organisation: [
        {
            sourceField: ["organisationId"],
            destField: ["id"],
            destSchema: "organisation",
            cardinality: "one",
        },
    ],
};
const organisationRelationships = {
    licences: [
        {
            sourceField: ["id"],
            destField: ["organisationId"],
            destSchema: "licence",
            cardinality: "many",
        },
    ],
    users: [
        {
            sourceField: ["id"],
            destField: ["organisationId"],
            destSchema: "organisationUser",
            cardinality: "many",
        },
    ],
};
const organisationUserRelationships = {
    organisation: [
        {
            sourceField: ["organisationId"],
            destField: ["id"],
            destSchema: "organisation",
            cardinality: "one",
        },
    ],
};
const sessionRelationships = {
    user: [
        {
            sourceField: ["userId"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
};
const userRelationships = {
    created: [
        {
            sourceField: ["createdBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    updated: [
        {
            sourceField: ["updatedBy"],
            destField: ["id"],
            destSchema: "user",
            cardinality: "one",
        },
    ],
    sessions: [
        {
            sourceField: ["id"],
            destField: ["userId"],
            destSchema: "session",
            cardinality: "many",
        },
    ],
    accounts: [
        {
            sourceField: ["id"],
            destField: ["userId"],
            destSchema: "account",
            cardinality: "many",
        },
    ],
};
/**
 * The Zero schema object.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const schema = {
    tables: {
        account: accountTable,
        adminUser: adminUserTable,
        licence: licenceTable,
        organisation: organisationTable,
        organisationUser: organisationUserTable,
        session: sessionTable,
        user: userTable,
    },
    relationships: {
        account: accountRelationships,
        licence: licenceRelationships,
        organisation: organisationRelationships,
        organisationUser: organisationUserRelationships,
        session: sessionRelationships,
        user: userRelationships,
    },
    enableLegacyQueries: false,
    enableLegacyMutators: false,
};
/**
 * Represents the ZQL query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const zql = createBuilder(schema);
/**
 * Represents the Zero schema query builder.
 * This type is auto-generated from your Drizzle schema definition.
 */
export const builder = zql;
//# sourceMappingURL=zero-schema.gen.js.map